// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "chart-bundle." + {"webpack_container_remote_chart_service_exposedFiles":"87d2f79b7883d113dec1","node_modules_protobufjs_inquire_sync_recursive-src_chartInstance_js":"ee5bc3b9067da146a5c0"}[chunkId] + ".js";
};